import { Alert, AlertProps, Collapse, CollapseProps, GridSpacing } from "@mui/material";
import React from "react";
import { IComponentParent } from "sonobello.utilities.react";

export interface ICollapsingAlert extends AlertProps, IComponentParent {
  /** Flag that when true will show the alert. */
  show: CollapseProps["in"];
  /** The optional top-margin for the alert when it is shown.
   * @remarks this prop is useful for controlling the top margin since the collapse swallows any inherited top-margin styling.
   */
  mt?: GridSpacing;
  /** Optional customization properties to be passed through to the {@link Collapse} element. */
  collapseProps?: Partial<Omit<CollapseProps, "in">>;
}

/** A convenience component which wraps an alert with given content and configuration in a collapsible container.
 * @remarks This component overrides all top-margin styling in an effort to appear invisible when collapsed. {@see ICollapsingAlert.mt}
 */
const CollapsingAlert: React.FC<ICollapsingAlert> = ({ children, mt, collapseProps, show, ...rest }) => {
  return (
    <Collapse
      {...collapseProps}
      in={show}
      sx={{ mt: show ? undefined : "0px !important", pt: "0px !important", ...collapseProps?.sx }}
    >
      <Alert {...rest} sx={{ mt, ...rest.sx }}>
        {children}
      </Alert>
    </Collapse>
  );
};

export default CollapsingAlert;
